import { BILLING, PAYOUT_METHODS } from 'ha/constants/pageNames';
import showWeWantToPay from './showWeWantToPay';

export default (state, pageName) =>
  pageName !== BILLING && pageName !== PAYOUT_METHODS && showWeWantToPay(state);
